module.exports = __webpack_public_path__ + "static/media/logo.1d85d093.png";